import { mergeModels, useModel, ref, watch, resolveComponent, createBlock, openBlock, withCtx, createVNode, createElementVNode, toDisplayString, createElementBlock, Fragment, renderList, unref } from "vue";
import "lodash-es";
import "moment";
import { isJsonString } from "../../utils/object-utils.js";
import "../../plugins/apollo.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import { VCard, VCardText, VCardActions } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import { VBottomSheet } from "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                            */
import "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/lookups.js";
import "../../graphql/entity.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                          */
/* empty css                         */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _hoisted_1 = { class: "text-center banza-section-header fs-32 lh-24 px-4" };
const _hoisted_2 = { class: "translations-grid grid-cols-2 gap-4" };
const _hoisted_3 = { class: "fs-16 color-gray mr-4" };
const _sfc_main = {
  __name: "BanzaTranslationsMenu",
  props: /* @__PURE__ */ mergeModels({
    isMultiline: {
      type: Boolean,
      default: false
    }
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "isVisible": {},
    "isVisibleModifiers": {}
  }),
  emits: ["update:modelValue", "update:isVisible"],
  setup(__props) {
    const { locales, locale } = useI18n();
    const value = useModel(__props, "modelValue");
    const isVisible = useModel(__props, "isVisible");
    const translations = ref({});
    const loadTranslations = () => {
      translations.value = isJsonString(value.value) ? JSON.parse(value.value) : { [locale.value]: value.value };
    };
    const save = () => {
      value.value = JSON.stringify(translations.value);
      close();
    };
    const close = () => {
      isVisible.value = false;
    };
    watch(
      () => isVisible.value,
      (val) => {
        if (val) {
          loadTranslations();
        }
      }
    );
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_text_edit = resolveComponent("b-text-edit");
      return openBlock(), createBlock(VBottomSheet, {
        "model-value": isVisible.value,
        "content-class": "banza-translations--bottom-dialog auto-height",
        scrollable: "",
        persistent: "",
        "no-click-animation": "",
        inset: ""
      }, {
        default: withCtx(() => [
          createVNode(VCard, { class: "d-flex pb-8" }, {
            default: withCtx(() => [
              createVNode(_component_b_btn, {
                tabindex: "-1",
                preset: "closeMini",
                class: "close-button",
                onClick: _cache[0] || (_cache[0] = ($event) => isVisible.value = false)
              }),
              createElementVNode("div", _hoisted_1, toDisplayString(_ctx.$t("components.admin.translations.translation")), 1),
              createVNode(VCardText, { class: "mt-8" }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_2, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(locales), (locale2) => {
                      return openBlock(), createElementBlock(Fragment, {
                        key: locale2.code
                      }, [
                        createElementVNode("span", _hoisted_3, toDisplayString(locale2.name), 1),
                        createVNode(_component_b_text_edit, {
                          modelValue: unref(translations)[locale2.code],
                          "onUpdate:modelValue": ($event) => unref(translations)[locale2.code] = $event,
                          label: locale2.name,
                          placeholder: _ctx.$t("components.admin.translations.translation"),
                          "is-multiline": __props.isMultiline
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder", "is-multiline"])
                      ], 64);
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              createVNode(VCardActions, { class: "mt-4 justify-center px-6" }, {
                default: withCtx(() => [
                  createVNode(_component_b_btn, {
                    class: "flex-grow-1",
                    preset: "cancel",
                    onClick: loadTranslations
                  }),
                  createVNode(_component_b_btn, {
                    class: "flex-grow-1",
                    preset: "save",
                    onClick: save
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFUcmFuc2xhdGlvbnNNZW51LnZ1ZTIuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RyYW5zbGF0aW9ucy9CYW56YVRyYW5zbGF0aW9uc01lbnUudnVlIl0sInNvdXJjZXNDb250ZW50IjpbIjx0ZW1wbGF0ZT5cblx0PHYtYm90dG9tLXNoZWV0IDptb2RlbC12YWx1ZT1cImlzVmlzaWJsZVwiIGNvbnRlbnQtY2xhc3M9XCJiYW56YS10cmFuc2xhdGlvbnMtLWJvdHRvbS1kaWFsb2cgYXV0by1oZWlnaHRcIiBzY3JvbGxhYmxlXG5cdFx0cGVyc2lzdGVudCBuby1jbGljay1hbmltYXRpb24gaW5zZXQ+XG5cdFx0PHYtY2FyZCBjbGFzcz1cImQtZmxleCBwYi04XCI+XG5cdFx0XHQ8Yi1idG4gdGFiaW5kZXg9XCItMVwiIHByZXNldD1cImNsb3NlTWluaVwiIGNsYXNzPVwiY2xvc2UtYnV0dG9uXCIgQGNsaWNrPVwiaXNWaXNpYmxlID0gZmFsc2VcIiAvPlxuXHRcdFx0PGRpdiBjbGFzcz1cInRleHQtY2VudGVyIGJhbnphLXNlY3Rpb24taGVhZGVyIGZzLTMyIGxoLTI0IHB4LTRcIj5cblx0XHRcdFx0e3sgJHQoXCJjb21wb25lbnRzLmFkbWluLnRyYW5zbGF0aW9ucy50cmFuc2xhdGlvblwiKSB9fVxuXHRcdFx0PC9kaXY+XG5cdFx0XHQ8di1jYXJkLXRleHQgY2xhc3M9XCJtdC04XCI+XG5cdFx0XHRcdDxkaXYgY2xhc3M9XCJ0cmFuc2xhdGlvbnMtZ3JpZCBncmlkLWNvbHMtMiBnYXAtNFwiPlxuXHRcdFx0XHRcdDx0ZW1wbGF0ZSB2LWZvcj1cImxvY2FsZSBpbiBsb2NhbGVzXCIgOmtleT1cImxvY2FsZS5jb2RlXCI+XG5cdFx0XHRcdFx0XHQ8c3BhbiBjbGFzcz1cImZzLTE2IGNvbG9yLWdyYXkgbXItNFwiPnt7IGxvY2FsZS5uYW1lIH19PC9zcGFuPlxuXHRcdFx0XHRcdFx0PGItdGV4dC1lZGl0IHYtbW9kZWw9XCJ0cmFuc2xhdGlvbnNbbG9jYWxlLmNvZGVdXCIgOmxhYmVsPVwibG9jYWxlLm5hbWVcIlxuXHRcdFx0XHRcdFx0XHQ6cGxhY2Vob2xkZXI9XCIkdCgnY29tcG9uZW50cy5hZG1pbi50cmFuc2xhdGlvbnMudHJhbnNsYXRpb24nKVwiXG5cdFx0XHRcdFx0XHRcdDppcy1tdWx0aWxpbmU9XCJpc011bHRpbGluZVwiIC8+XG5cdFx0XHRcdFx0PC90ZW1wbGF0ZT5cblx0XHRcdFx0PC9kaXY+XG5cdFx0XHQ8L3YtY2FyZC10ZXh0PlxuXHRcdFx0PHYtY2FyZC1hY3Rpb25zIGNsYXNzPVwibXQtNCBqdXN0aWZ5LWNlbnRlciBweC02XCI+XG5cdFx0XHRcdDxiLWJ0biBjbGFzcz1cImZsZXgtZ3Jvdy0xXCIgcHJlc2V0PVwiY2FuY2VsXCIgQGNsaWNrPVwibG9hZFRyYW5zbGF0aW9uc1wiIC8+XG5cdFx0XHRcdDxiLWJ0biBjbGFzcz1cImZsZXgtZ3Jvdy0xXCIgcHJlc2V0PVwic2F2ZVwiIEBjbGljaz1cInNhdmVcIiAvPlxuXHRcdFx0PC92LWNhcmQtYWN0aW9ucz5cblx0XHQ8L3YtY2FyZD5cblx0PC92LWJvdHRvbS1zaGVldD5cbjwvdGVtcGxhdGU+XG5cbjxzY3JpcHQgc2V0dXA+XG5pbXBvcnQgeyBpc0pzb25TdHJpbmcgfSBmcm9tIFwiQC91dGlsc1wiO1xuaW1wb3J0IHsgdXNlSTE4biB9IGZyb20gXCJAL2NvbXBvc2FibGVzXCI7XG5cbmNvbnN0IHsgbG9jYWxlcywgbG9jYWxlIH0gPSB1c2VJMThuKCk7XG5cbmNvbnN0IHZhbHVlID0gZGVmaW5lTW9kZWwoKTtcbmNvbnN0IGlzVmlzaWJsZSA9IGRlZmluZU1vZGVsKFwiaXNWaXNpYmxlXCIpO1xuY29uc3QgcHJvcHMgPSBkZWZpbmVQcm9wcyh7XG5cdGlzTXVsdGlsaW5lOiB7XG5cdFx0dHlwZTogQm9vbGVhbixcblx0XHRkZWZhdWx0OiBmYWxzZSxcblx0fSxcbn0pO1xuXG5jb25zdCB0cmFuc2xhdGlvbnMgPSByZWYoe30pO1xuXG5jb25zdCBsb2FkVHJhbnNsYXRpb25zID0gKCkgPT4ge1xuXHR0cmFuc2xhdGlvbnMudmFsdWUgPSBpc0pzb25TdHJpbmcodmFsdWUudmFsdWUpXG5cdFx0PyBKU09OLnBhcnNlKHZhbHVlLnZhbHVlKVxuXHRcdDogeyBbbG9jYWxlLnZhbHVlXTogdmFsdWUudmFsdWUgfTtcbn07XG5cbmNvbnN0IHNhdmUgPSAoKSA9PiB7XG5cdHZhbHVlLnZhbHVlID0gSlNPTi5zdHJpbmdpZnkodHJhbnNsYXRpb25zLnZhbHVlKTtcblx0Y2xvc2UoKTtcbn07XG5cbmNvbnN0IGNsb3NlID0gKCkgPT4ge1xuXHRpc1Zpc2libGUudmFsdWUgPSBmYWxzZTtcbn07XG5cbndhdGNoKFxuXHQoKSA9PiBpc1Zpc2libGUudmFsdWUsXG5cdCh2YWwpID0+IHtcblx0XHRpZiAodmFsKSB7XG5cdFx0XHRsb2FkVHJhbnNsYXRpb25zKCk7XG5cdFx0fVxuXHR9XG4pO1xuPC9zY3JpcHQ+XG5cbjxzdHlsZSBsYW5nPVwic2Nzc1wiPlxuLmJhbnphLXRyYW5zbGF0aW9ucy0tYm90dG9tLWRpYWxvZyB7XG5cdGJvcmRlci1yYWRpdXM6IG1pbig4OHB4LCA4dncpIG1pbig4OHB4LCA4dncpIDBweCAwcHggIWltcG9ydGFudDtcblxuXHQudi1jYXJkIHtcblxuXHRcdGJvcmRlci1yYWRpdXM6IG1pbig4OHB4LCA4dncpIG1pbig4OHB4LCA4dncpIDBweCAwcHggIWltcG9ydGFudDtcblx0XHRtaW4taGVpZ2h0OiBtaW4oNzg3cHgsIDkwdmgpO1xuXHRcdGJhY2tncm91bmQ6ICNmZmY7XG5cdFx0Ly8gcGFkZGluZzogbWluKDUwcHgsIDd2aCkgbWluKDEwMHB4LCAxMHZ3KSBtaW4oNzZweCwgN3Z3KSBtaW4oMTAwcHgsIDEwdncpO1xuXHRcdHBhZGRpbmc6IG1pbig1MHB4LCA3dmgpIG1pbigzMHB4LCAzdncpIG1pbig3NnB4LCA3dncpIG1pbigzMHB4LCAzdncpO1xuXG5cdFx0Ly8gLnYtY2FyZC10ZXh0IHtcblx0XHQvLyBcdHBhZGRpbmc6IDAgbWluKDcwcHgsIDd2dykgIWltcG9ydGFudDtcblx0XHQvLyB9XG5cdFx0PmRpdiB7XG5cdFx0XHRwYWRkaW5nLWxlZnQ6IG1pbig3MHB4LCA3dncpICFpbXBvcnRhbnQ7XG5cdFx0XHRwYWRkaW5nLXJpZ2h0OiBtaW4oNzBweCwgN3Z3KSAhaW1wb3J0YW50O1xuXHRcdH1cblxuXHRcdC5iYW56YS1zZWN0aW9uLWhlYWRlciB7XG5cdFx0XHRjb2xvcjogIzJkMmQyZDtcblx0XHRcdGZvbnQtc2l6ZTogMzRweDtcblx0XHRcdGZvbnQtd2VpZ2h0OiA3MDA7XG5cdFx0XHRsZXR0ZXItc3BhY2luZzogLTAuNjhweDtcblx0XHR9XG5cblx0XHQuY2xvc2UtYnV0dG9uIHtcblx0XHRcdHBvc2l0aW9uOiBhYnNvbHV0ZTtcblx0XHRcdHJpZ2h0OiBtaW4oNDhweCwgNHZ3KTtcblx0XHRcdHRvcDogMzJweDtcblx0XHR9XG5cblx0XHQuZmllbGRzLWJsb2NrIHtcblx0XHRcdGRpc3BsYXk6IGdyaWQ7XG5cdFx0XHRncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdChhdXRvLWZpdCwgbWlubWF4KG1heCg0MCUsIDIwMHB4KSwgMWZyKSk7XG5cdFx0fVxuXG5cdFx0LnYtY2FyZF9fdW5kZXJsYXkge1xuXHRcdFx0ZGlzcGxheTogbm9uZTtcblx0XHR9XG5cdH1cblxuXHQmLmF1dG8taGVpZ2h0IHtcblx0XHQudi1jYXJkIHtcblx0XHRcdG1pbi1oZWlnaHQ6IGF1dG87XG5cdFx0fVxuXHR9XG5cblx0LnRyYW5zbGF0aW9ucy1ncmlkIHtcblx0XHRkaXNwbGF5OiBncmlkO1xuXHRcdGdyaWQtdGVtcGxhdGUtY29sdW1uczogbWF4LWNvbnRlbnQgMWZyO1xuXHRcdGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5cblx0XHQuY29sb3ItZ3JheSB7XG5cdFx0XHRjb2xvcjogIzkyOWZhYyAhaW1wb3J0YW50O1xuXHRcdH1cblx0fVxuXG5cdC52LWNhcmQge1xuXG5cdFx0LnYtY2FyZC10ZXh0LFxuXHRcdC52LWNhcmQtYWN0aW9ucyB7XG5cdFx0XHRmbGV4LWdyb3c6IDA7XG5cdFx0XHR3aWR0aDogbWluKDEwMCUsIDcyMHB4KTtcblx0XHRcdG1hcmdpbjogMCBhdXRvO1xuXHRcdH1cblx0fVxufVxuPC9zdHlsZT5cbiJdLCJuYW1lcyI6WyJfdXNlTW9kZWwiLCJfY3JlYXRlQmxvY2siLCJfY29tcG9uZW50X3ZfYm90dG9tX3NoZWV0IiwiX2NyZWF0ZVZOb2RlIiwiX2NvbXBvbmVudF92X2NhcmQiLCJfY3JlYXRlRWxlbWVudFZOb2RlIiwiX3RvRGlzcGxheVN0cmluZyIsIiR0IiwiX2NvbXBvbmVudF92X2NhcmRfdGV4dCIsIl9jcmVhdGVFbGVtZW50QmxvY2siLCJfRnJhZ21lbnQiLCJfcmVuZGVyTGlzdCIsIl91bnJlZiIsImxvY2FsZSIsIl9jb21wb25lbnRfdl9jYXJkX2FjdGlvbnMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUE4QkEsVUFBTSxFQUFFLFNBQVMsT0FBUSxJQUFHLFFBQVM7QUFFckMsVUFBTSxRQUFRQSw4QkFBWTtBQUMxQixVQUFNLFlBQVlBLFNBQVcsU0FBQyxXQUFXO0FBUXpDLFVBQU0sZUFBZSxJQUFJLEVBQUU7QUFFM0IsVUFBTSxtQkFBbUIsTUFBTTtBQUM5QixtQkFBYSxRQUFRLGFBQWEsTUFBTSxLQUFLLElBQzFDLEtBQUssTUFBTSxNQUFNLEtBQUssSUFDdEIsRUFBRSxDQUFDLE9BQU8sS0FBSyxHQUFHLE1BQU0sTUFBTztBQUFBLElBQ25DO0FBRUEsVUFBTSxPQUFPLE1BQU07QUFDbEIsWUFBTSxRQUFRLEtBQUssVUFBVSxhQUFhLEtBQUs7QUFDL0MsWUFBTztBQUFBLElBQ1I7QUFFQSxVQUFNLFFBQVEsTUFBTTtBQUNuQixnQkFBVSxRQUFRO0FBQUEsSUFDbkI7QUFFQTtBQUFBLE1BQ0MsTUFBTSxVQUFVO0FBQUEsTUFDaEIsQ0FBQyxRQUFRO0FBQ1IsWUFBSSxLQUFLO0FBQ1IsMkJBQWtCO0FBQUEsUUFDckI7QUFBQSxNQUNBO0FBQUEsSUFDQTs7OzswQkFoRUNDLFlBc0JpQkMsY0FBQTtBQUFBLFFBdEJBLGVBQWEsVUFBUztBQUFBLFFBQUUsaUJBQWM7QUFBQSxRQUFnRCxZQUFBO0FBQUEsUUFDdEcsWUFBQTtBQUFBLFFBQVcsc0JBQUE7QUFBQSxRQUFtQixPQUFBO0FBQUE7eUJBQzlCLE1BbUJTO0FBQUEsVUFuQlRDLFlBbUJTQyxPQUFBLEVBbkJELE9BQU0sY0FBYSxHQUFBO0FBQUEsNkJBQzFCLE1BQTBGO0FBQUEsY0FBMUZELFlBQTBGLGtCQUFBO0FBQUEsZ0JBQW5GLFVBQVM7QUFBQSxnQkFBSyxRQUFPO0FBQUEsZ0JBQVksT0FBTTtBQUFBLGdCQUFnQiwrQ0FBTyxVQUFTLFFBQUE7QUFBQTtjQUM5RUUsbUJBRU0sT0FGTixZQUVNQyxnQkFERkMsS0FBRSxHQUFBLDJDQUFBLENBQUEsR0FBQSxDQUFBO0FBQUEsY0FFTkosWUFTY0ssV0FBQSxFQVRELE9BQU0sT0FBTSxHQUFBO0FBQUEsaUNBQ3hCLE1BT007QUFBQSxrQkFQTkgsbUJBT00sT0FQTixZQU9NO0FBQUEsc0NBTkxJLG1CQUtXQyxVQUFBLE1BQUFDLFdBTGdCQyxNQUFPLE9BQUEsR0FBQSxDQUFqQkMsWUFBTTs7d0JBQW1CLEtBQUFBLFFBQU87QUFBQTt3QkFDaERSLG1CQUE0RCxRQUE1RCxZQUF1Q0MsZ0JBQUFPLFFBQU8sSUFBSSxHQUFBLENBQUE7QUFBQSx3QkFDbERWLFlBRStCLHdCQUFBO0FBQUEsc0NBRlRTLE1BQVksWUFBQSxFQUFDQyxRQUFPLElBQUk7QUFBQSw2REFBeEJELE1BQVksWUFBQSxFQUFDQyxRQUFPLElBQUksSUFBQTtBQUFBLDBCQUFJLE9BQU9BLFFBQU87QUFBQSwwQkFDOUQsYUFBYU4sS0FBRSxHQUFBLDJDQUFBO0FBQUEsMEJBQ2YsZ0JBQWMsUUFBVztBQUFBOzs7Ozs7O2NBSTlCSixZQUdpQlcsY0FBQSxFQUhELE9BQU0sMkJBQTBCLEdBQUE7QUFBQSxpQ0FDL0MsTUFBdUU7QUFBQSxrQkFBdkVYLFlBQXVFLGtCQUFBO0FBQUEsb0JBQWhFLE9BQU07QUFBQSxvQkFBYyxRQUFPO0FBQUEsb0JBQVUsU0FBTztBQUFBO2tCQUNuREEsWUFBeUQsa0JBQUE7QUFBQSxvQkFBbEQsT0FBTTtBQUFBLG9CQUFjLFFBQU87QUFBQSxvQkFBUSxTQUFPO0FBQUE7Ozs7Ozs7Ozs7Ozs7In0=
